// test2973
(2973 && 0);
